/* eslint-disable @typescript-eslint/no-explicit-any */
import { useIntl } from 'react-intl'

interface FormatMessageValues {
  [key: string]: any
}

// TODO: Add unit test to hook useFormatMessage
function useFormatMessage() {
  const intl = useIntl()

  return (id: string, defaultMessage: string, values?: FormatMessageValues) =>
    intl.formatMessage({ id, defaultMessage }, values)
}

export default useFormatMessage
